export const COOKIE_CONSENT_COOKIE_NAME = "alpha_cookie_consent";
export const CONSENT_CHANGED_EVENT = "alpha-cookie-consent-change";

export const CONSENT_CATEGORIES = {
  NECESSARY: "necessary",
  ANALYTICS: "analytics",
  MARKETING: "marketing",
} as const;

export type ConsentCategory =
  (typeof CONSENT_CATEGORIES)[keyof typeof CONSENT_CATEGORIES];

